export const updateSource = ({ map, sourceName, geoJSON }) => {
	const source = map.getSource(sourceName);

	if (source) source.setData(geoJSON);
};
